import { initialState } from 'src/contexts/settings/settings-context';
import { therapyPlanningAction } from '../../actions/constant';

const {
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
  isFuturePlan: false,
  loading: false,
};

export const checkTherapyPlanningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        isFuturePlan: true,
        loading: false,
      };
    }

    case CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        isFuturePlan: false,
        loading: false,
      };

    case CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET:
      return intitialstate;

    default:
      return state;
  }
};
